import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['pap', 'agency', 'submitButton', 'tooltip']

  connect() {
    if (this.hasPapTarget) this.changeColor(this.papTarget)
    if (this.hasAgencyTarget) this.changeColor(this.agencyTarget)
  }

  select(event) {
    this.changeColor(event.target)

    setTimeout(() => {
      window.location.reload(); // recharger la page pour afficher le flash
    }, 500);
  }

  changeColor(target) {
    let colors = JSON.parse(target.dataset.color);
    let color = colors.find(pair => pair[0] === target.value);

    target.className = '';
    target.classList.add('competition-input');
    if (color === undefined) return;

    target.classList.add('vesta-' + color[1] + '-100');
  }
}
